// extracted by extract-css-chunks-webpack-plugin
module.exports = {"userDetails":"_6dMQG"};